import { postData } from "./PostData";
import { global } from "./Global";

export const coupon = () => {
  const manipulateCouponInput = (e) => {
    if (e.target && e.target.id === "show-coupon-form") {
      e.preventDefault();

      const couponShow = e.target.nextElementSibling;
      couponShow.classList.toggle("active");
    }
  };

  document.addEventListener("click", manipulateCouponInput);

  window.coupon = () => {
    return {
      couponCode: "",

      addDiscount() {
        document.getElementById("loader").style.display = "flex";

        const form = new FormData();

        form.append("action", "add_discount");
        form.append("couponCode", this.couponCode);
        form.append("_ajax_nonce", my_ajax_object.nonce);
        form.append("blocksToUpdate", global.getBlocksToUpdate());

        const params = new URLSearchParams(form);

        postData(my_ajax_object.ajax_url, params).then((response) => {
          document.getElementById("loader").style.display = "none";

          if (!response || response.error) {
            return;
          }

          global.updateBlocks(response);
        });
      },
    };
  };
  window.couponList = () => {
    return {
      removeCoupon(couponCode) {
        document.getElementById("loader").style.display = "flex";

        const form = new FormData();

        form.append("action", "remove_discount");
        form.append("couponCode", couponCode);
        form.append("_ajax_nonce", my_ajax_object.nonce);
        form.append("blocksToUpdate", global.getBlocksToUpdate());

        const params = new URLSearchParams(form);

        postData(my_ajax_object.ajax_url, params).then((response) => {
          document.getElementById("loader").style.display = "none";

          if (!response || response.error) {
            return;
          }

          global.updateBlocks(response);
        });
      },
    };
  };
};
